import LinearProgress from '@mui/material/LinearProgress';
import { withStyles } from '@mui/styles';

import suspenseLogo from '../../assets/suspense.png';
import CenteredLogo from './CenteredLogo';

const BorderLinearProgress = withStyles({
  root: {
    height: 8,
    backgroundColor: 'secondary',
  },
  bar: {
    borderRadius: 20,
    backgroundColor: 'secondary',
  },
})(LinearProgress);
const SuspenseLoader = (props) => {
  return (
    <div style={{ width: '100%', textAlign: 'center' }}>
      <BorderLinearProgress color="secondary" />
      {/* <BouncingLogo logo={suspenseLogo} size={200} /> */}
      <CenteredLogo logo={suspenseLogo} size={200} opacity={0.3} />
    </div>
  );
};

export default SuspenseLoader;
